module.exports = __webpack_public_path__ + "img/1.7e1fc8ed.jpg";